// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import { Versioning } from "@hex-insights/app-modules";
import { appRequest } from "@hex-insights/verita-romania.shared";

const localVersion = process.env.REACT_APP_VERSION ?? "";

export function VersionController() {
	return <Versioning.VersionController version={localVersion} getCurrentVersion={getCurrentVersion} />;
}

async function getCurrentVersion() {
	const response = await appRequest("/meta.json", { cache: "no-cache" });
	if (!response.ok) {
		return undefined;
	}
	let responseJSON: any;
	try {
		responseJSON = await response.json();
	} catch {
		return undefined;
	}
	return responseJSON.version;
}
